import { colors } from '@lmc/common/constants'
import type { HomeSource } from '@lmc/ts-common'
import { EmarModuleCard, FamilyPlanModuleCard, IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import type React from 'react'
import { connect } from 'react-redux'
import { PaywallTemplateWrapper } from '../PaywallTemplateWrapper'

interface StateProps {
  title?: string
  subTitle?: string
  source?: HomeSource
}

export const ProPaywallComponent: React.FC<StateProps> = ({
  title,
  subTitle,
  source
}) => {
  const isSelfServe = source === 'Self-serve'

  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title={title || 'Pro Plan'}
      subTitle={
        subTitle ||
        'Deliver and evidence people-centred care with helpful features such as care plans, risk assessments, consent management, handovers, photos, body maps and many more.'
      }
      bodyText={
        isSelfServe
          ? 'Start your 1 month free trial now.'
          : 'Interested in going pro?'
      }
      icon={IconType.ProHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'How do I get started with a Pro plan?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/collections/794905-getting-started',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'How much does it cost?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/1584269-how-much-does-it-cost',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'What features are in the Pro plan?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/pricing"
    />
  )
}

const mapStateToProps = (state: any) => ({
  source: state.global?.home?.source
})

export const ProPaywall = connect(mapStateToProps)(ProPaywallComponent)
